import { api } from "@/lib/api";

// The 12 required fields that make an avatar "complete" (matches AVATAR_REQUIRED
// on the backend). Lazy/optional fields never count toward completion.
export const AVATAR_REQUIRED_FIELDS = [
  "nome",
  "faixa_etaria",
  "nicho",
  "contexto_vida",
  "dores",
  "frustracoes",
  "medos",
  "desejos",
  "objecoes",
  "comportamento",
  "linguagem_real",
  "matriz_estrategica",
];

export function countAvatarFields(avatar) {
  if (!avatar) return 0;
  return AVATAR_REQUIRED_FIELDS.filter((f) => avatar[f]).length;
}

// One-tap avatar creation (FR29 / Story 4.4): POST a draft and go straight to the
// builder in voice mode. If a draft already exists (409), hand the draft id back
// to the caller so it can offer "continue vs discard" instead of bouncing.
export async function startAvatarCreation({ nav, onDraftExists, mode = "voice" }) {
  try {
    const { data } = await api.post("/avatars", { created_via: mode });
    nav(`/avatars/${data.id}/builder?mode=${mode}`);
    return { created: true, id: data.id };
  } catch (err) {
    const draftId = err?.response?.data?.detail?.draft_id;
    if (err?.response?.status === 409 && draftId) {
      if (onDraftExists) {
        onDraftExists(draftId);
        return { created: false, draftId };
      }
      nav(`/avatars/${draftId}/builder?mode=${mode}`);
      return { created: false, draftId };
    }
    throw err;
  }
}

export async function discardDraft() {
  await api.delete("/avatars/drafts");
}
